(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 28);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global $ */

/**
 *  Util initialization Class. Provides public functions
 *  - getCurrentTimeISOStandard
 *  - getCurrentTime
 *  - getCookie
 *  - getAppVersion
 *  - logInfoToBackend
 *  - updateStatementObjectToPostToLRS
 *  - createStatementObject
 */
var Utils = function () {
    function Utils() {
        _classCallCheck(this, Utils);
    }

    _createClass(Utils, null, [{
        key: 'getCurrentTimeISOStandard',
        value: function getCurrentTimeISOStandard(date) {
            var timezoneOffsetMin = date.getTimezoneOffset(),
                offsetHrs = parseInt(Math.abs(timezoneOffsetMin / 60), 10),
                offsetMin = Math.abs(timezoneOffsetMin % 60),
                timezoneStandard = void 0;

            if (offsetHrs < 10) {
                offsetHrs = '0' + offsetHrs;
            }

            if (offsetMin < 10) {
                offsetMin = '0' + offsetMin;
            }

            // Add an opposite sign to the offset // If offset is 0, it means timezone is UTC
            // Timezone difference in hours and minutes // String such as +5:30 or -6:00 or Z
            if (timezoneOffsetMin < 0) {
                timezoneStandard = '+' + offsetHrs + ':' + offsetMin;
            } else if (timezoneOffsetMin > 0) {
                timezoneStandard = '-' + offsetHrs + ':' + offsetMin;
            } else if (timezoneOffsetMin === 0) {
                timezoneStandard = 'Z';
            }

            var dt = date,
                currentDate = dt.getDate(),
                currentMonth = dt.getMonth() + 1,
                currentYear = dt.getFullYear(),
                currentHrs = dt.getHours(),
                currentMins = dt.getMinutes(),
                currentSecs = dt.getSeconds(),
                currentMillisecs = dt.getMilliseconds(),
                currentDatetime = void 0;

            // Add 0 before date, month, hrs, mins or secs if they are less than 0
            currentDate = currentDate < 10 ? '0' + currentDate : currentDate;
            currentMonth = currentMonth < 10 ? '0' + currentMonth : currentMonth;
            currentHrs = currentHrs < 10 ? '0' + currentHrs : currentHrs;
            currentMins = currentMins < 10 ? '0' + currentMins : currentMins;
            currentSecs = currentSecs < 10 ? '0' + currentSecs : currentSecs;
            currentMillisecs = currentMillisecs < 10 ? '0' + currentMillisecs : currentMillisecs;
            currentMillisecs = currentMillisecs < 100 ? '0' + currentMillisecs : currentMillisecs;

            currentDatetime = currentYear + '-' + currentMonth + '-' + currentDate + 'T' + currentHrs + ':' + currentMins + ':' + currentSecs + '.' + currentMillisecs;

            return currentDatetime + timezoneStandard;
        }
    }, {
        key: 'getCurrentTime',
        value: function getCurrentTime(date) {
            var hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
            var amPm = date.getHours() >= 12 ? 'PM' : 'AM';
            hours = hours < 10 ? '0' + hours : hours;
            var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
            var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            return (/* date.toLocaleDateString() + */hours + ':' + minutes + ':' + seconds + ' ' + amPm
            );
        }

        /** Function to get cookie - needed to set csrf-token in ajax headers
         * @param {string} name - Cookie name
        */

    }, {
        key: 'getCookie',
        value: function getCookie(name) {
            var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
            if (match) return match[2];
        }

        /* Function to get app version - needed to set version in ajax headers */

    }, {
        key: 'getAppVersion',
        value: function getAppVersion() {
            return 'v2';
        }

        /**
         * Wrapper around jQuery's AJAX request
         * @param {string} url - Request URL
         * @param {Function} successCallback - Success callback
         * @param {Function} errorCallback - Error handler
         * @param {('GET'|'POST'|'PUT'|'DELETE')} [requestType=GET] - 'GET'/'POST'/'PUT'/'DELETE' Request
         * @param {*} [options={}] - Other required inputs
         *        {string} userId - User ID
         * @param {*} [payload=null] - Request payload
         */

    }, {
        key: 'sendAjaxRequest',
        value: function sendAjaxRequest(url, successCallback, errorCallback) {
            var requestType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'GET';
            var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
            var payload = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

            var params = {
                url: url,
                type: requestType || 'GET',
                headers: {
                    'csrf-token': Utils.getCookie('csrf-token'),
                    'cambridgeone-app-version': Utils.getAppVersion(),
                    'user-id': options.userId
                },
                xhrFields: { withCredentials: true }
            };

            if (payload) {
                params.data = payload;
            }

            if (requestType === 'GET' || requestType === 'DELETE') {
                params.cache = false;
            }

            return $.ajax(params).then(successCallback, errorCallback);
        }

        /** Function to log info to backend
         * @param {string} context
         * @param {string} extUserId
         * @param {string} spaceId
         * @param {string} productCode
         * @param {string} [classId]
         * @param {object} [data]
         * @param {object} [options]
         * @param {string} [options.serverRoutePrefix]
         * @param {string} [options.queryParams]
         */

    }, {
        key: 'logInfoToBackend',
        value: async function logInfoToBackend(context, extUserId, spaceId, productCode) {
            var classId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
            var data = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
            var options = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

            var payload = {
                context: context,
                extUserId: extUserId,
                spaceId: spaceId,
                classId: classId,
                productCode: productCode,
                data: data,
                'isUserInfoNeeded': true
            };

            var url = (options.serverRoutePrefix || '') + 'logger' + (options.queryParams || '');
            var successCallback = function successCallback(response) {
                return response;
            };

            var errorCallback = function handleError(error) {
                if (error.status === 503 || error.status === 403 && error.responseJSON && error.responseJSON.code === 'STALE_REQUEST') {
                    window.location.reload();
                } else {
                    throw error;
                }
            };
            return Utils.sendAjaxRequest(url, successCallback, errorCallback, 'POST', { userId: extUserId }, payload);
        }

        /**
         * State size should not be greater than 10 kB
         * @param {*} state
         * @return {boolean}
         */

    }, {
        key: 'isStateSizeValid',
        value: function isStateSizeValid(state) {
            return new TextEncoder().encode(JSON.stringify(state)).length / 1024 <= 10;
        }

        /** Function to update statement object to post to ComproDLS LRS.
         *  This function merge statementData from local storage(if any) with the statementArray else creates a new statementObject to store in local storage.
         *  @param {Array} statementsArray
         *  @param {Object} options
         *  @return {Object} statementData OR [entitiesArr, verbsHash]
         */

    }, {
        key: 'updateStatementObjectToPostToLRS',
        value: function updateStatementObjectToPostToLRS(statementsArray) {
            var _this = this,
                _statementData$entiti;

            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var verbsHash = {},
                entitiesArr = [];
            statementsArray.forEach(function (statement) {
                var _updateStatementEntit = _this.updateStatementEntities(statement, options),
                    _updateStatementEntit2 = _slicedToArray(_updateStatementEntit, 2),
                    entitiesObj = _updateStatementEntit2[0],
                    verb = _updateStatementEntit2[1];

                verbsHash[verb] = true;
                entitiesArr.push(entitiesObj);
            });

            if (options.isStatementToBeStoredInLocalStorage) return [entitiesArr, verbsHash];

            var statementData = this.createStatementObject(statementsArray, options);
            (_statementData$entiti = statementData.entities).push.apply(_statementData$entiti, entitiesArr);
            return statementData;
        }

        /** Function to create statement object to post to ComproDLS LRS.
         *  @param {Array} statementsArray
         *  @param {Object} options
         *  @return {Object} statementObject
         */

    }, {
        key: 'createStatementObject',
        value: function createStatementObject(statementsArray) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var statementObject = {
                'actor': {
                    'uuid': ''
                },
                'platform': {
                    'ua': ''
                },
                'entities': []
            };

            if (options.platformId && options.xapiId) {
                statementObject.debug = {
                    'id': options.platformId,
                    'xapiId': options.xapiId
                };
            }

            if (options.productCode) {
                statementObject.product = { 'code': options.productCode };
            }

            if (options.spaceId) {
                statementObject['space_key'] = options.spaceId;
            }

            if (options.userDetails && options.userDetails.userRole) {
                statementObject.actor.role = options.userDetails.userRole;
            }

            if (options.classId) {
                statementObject.classid = options.classId;
            }

            if (statementsArray[0].json && statementsArray[0].json.context) {
                statementObject.platform.ua = statementsArray[0].json.context.platform.ua;
                if (statementsArray[0].json.context.platform.session) statementObject.platform.session = statementsArray[0].json.context.platform.session;
            }

            if (statementsArray[0].json && statementsArray[0].json['student_userid']) {
                statementObject['student_userid'] = statementsArray[0].json['student_userid'];
            }

            if (statementsArray[0].json && statementsArray[0].json['custom_component']) {
                statementObject['custom_component'] = {
                    'code': statementsArray[0].json['custom_component'].code,
                    'title': statementsArray[0].json['custom_component'].title
                };
            }

            if (statementsArray[0].json && statementsArray[0].json.tags) {
                if (!statementObject.product) {
                    statementObject.product = {};
                }
                statementObject.product.tags = statementsArray[0].json.tags;
                if (statementsArray[0].json.definition) {
                    statementObject.product.definition = statementsArray[0].json.definition;
                }
            }

            /* For collab-group statements */
            if (statementsArray[0].json && statementsArray[0].json.group) {
                statementObject.group = statementsArray[0].json.group;
            }

            return statementObject;
        }

        /** Function to update statements object entities to post to ComproDLS LRS.
         *  @param {Object} statement
         *  @param {Object} options
         *  @return {Array} [entitiesJson, verbId]
         */

    }, {
        key: 'updateStatementEntities',
        value: function updateStatementEntities(statement, options) {
            var entitiesJson = {},
                statementJson = statement.json,
                verbId = void 0;
            if (options.assignedPathId) {
                entitiesJson['assigned_path_id'] = options.assignedPathId;
            }

            for (var key in statementJson) {
                switch (key) {
                    case 'verb':
                        {
                            verbId = statementJson[key].id.split('/');
                            verbId = verbId[verbId.length - 1];
                            entitiesJson[key] = verbId;
                            break;
                        }
                    case 'object':
                        {
                            if (statementJson[key].id) {
                                entitiesJson['item-code'] = statementJson[key].id;
                            }
                            if (statementJson[key].itemid) {
                                entitiesJson['itemid'] = statementJson[key].itemid;
                            }
                            break;
                        }
                    case 'timestamp':
                        {
                            entitiesJson[key] = this.convertTimestampToEpoc(statementJson[key]);
                            break;
                        }
                    case 'result':
                        {
                            if (statementJson[key].duration) {
                                entitiesJson['timespent'] = this.convertTimespentToEpoc(statementJson[key].duration);
                                delete statementJson[key].duration;
                            }
                            if (Object.keys(statementJson[key]).length > 0) {
                                entitiesJson[key] = statementJson[key];
                            }
                            break;
                        }
                    case 'attempt':
                        {
                            if (Object.keys(statementJson[key]).length > 0) {
                                entitiesJson[key] = statementJson[key];
                            }
                            break;
                        }
                    case 'audit_data':
                        {
                            if (Object.keys(statementJson[key]).length > 0) {
                                //Assuming timestamp will be present in statementJson as its generated in XAPIDataGenerator
                                statementJson[key]['reset_time'] = this.convertTimestampToEpoc(statementJson['timestamp']);
                                entitiesJson[key] = statementJson[key];
                            }
                            break;
                        }
                    case 'link-statementid':
                    case 'ext_link_id':
                    case 'submission_order':
                    case 'user_data':
                    case 'item-filename':
                    case 'override':
                    case 'deleted':
                    case 'item-tags':
                    case 'item-type':
                    case 'ltiPlatform':
                    case 'meta':
                    case 'audit':
                    case 'item_ext_url':
                    case 'item_title':
                    case 'xapi':
                    case 'ttl':
                        {
                            entitiesJson[key] = statementJson[key];
                            break;
                        }
                }
            }
            return [entitiesJson, verbId];
        }

        /** Function to covert timestamp to epoc standard to post to comproDLS LRS.
        *  @param {Date} time format - 2018-03-06T16:10:15.553+05:30
        *  @return {Number} time in epoc msecs
        */

    }, {
        key: 'convertTimestampToEpoc',
        value: function convertTimestampToEpoc(time) {
            var date = new Date(time);
            return date.getTime();
        }

        /** Function to covert timespent to epoc standard to post to comproDLS LRS.
         *  @param {String} time format - PT35M48.90S
         *  @return {Number} time in epoc msecs
         */

    }, {
        key: 'convertTimespentToEpoc',
        value: function convertTimespentToEpoc(time) {
            var date = time.split('PT')[1],
                timespent = 0;
            if (date.indexOf('H') >= 0) {
                var hrs = date.split('H')[0];
                date = date.split('H')[1];
                timespent += hrs * 60 * 60;
            }
            if (date.indexOf('M') >= 0) {
                var mins = date.split('M')[0];
                date = date.split('M')[1];
                timespent += mins * 60;
            }
            if (date.indexOf('S') >= 0) {
                var secs = date.split('S')[0];
                timespent += secs * 1;
            }

            return timespent * 1000;
        }

        /**
         * Checks whether the state/statement from reference class is useable for the current class and product type
         * @param {string} referenceClassId
         * @param {string} currentClassId
         * @param {boolean} [isCBPClass=false]
         * @param {boolean} [isTestTypeProduct=false]
         * @returns {boolean}
         */

    }, {
        key: 'isSyncingAllowed',
        value: function isSyncingAllowed(referenceClassId, currentClassId) {
            var isCBPClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var isTestTypeProduct = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            return (!isCBPClass || referenceClassId === currentClassId) && (!isTestTypeProduct || !referenceClassId || referenceClassId === currentClassId);
        }
    }]);

    return Utils;
}();

exports.default = Utils;
module.exports = exports['default'];

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
      value: true
});
exports.XAPIDataGenerator = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _helper = __webpack_require__(1);

var _helper2 = _interopRequireDefault(_helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *  XAPIDataGenerator initialization Class. Provides public functions
 *  -generateCustomStatement()
 */
var XAPIDataGenerator = function () {
      function XAPIDataGenerator() {
            _classCallCheck(this, XAPIDataGenerator);
      }

      _createClass(XAPIDataGenerator, null, [{
            key: 'generateCustomStatement',


            /**
             * Function called by APP to generate a custom statement - used for p+ content (launched and downlaoded).
             * @param {String} uniqueID
             * @param {String} verb
             * @param {Object} options
             * @return {Object} statementObject - Default TinCan format; If options.isDLSFormat true then DLS format statement.
             */
            value: function generateCustomStatement(uniqueID, verb) {
                  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

                  options = Object.assign({}, options, {
                        description: verb,
                        mode: 'Container'
                  });

                  var tinCanStatement = this.generateStatement(uniqueID, verb, options);
                  if (!options.isDLSFormat) return tinCanStatement;else return _helper2.default.updateStatementObjectToPostToLRS(tinCanStatement, options.dlsStatementParams);
            }

            //Function called to directly generate a statement i.e there is no xapiRunner.paintActivity done
            //options - description, mode and other keys, if any

      }, {
            key: 'generateStatement',
            value: function generateStatement(uniqueID, verb, options) {
                  var interpretedStatementsArray = [],
                      interpretedStatement = {};
                  var dateTime = options.date || new Date();

                  interpretedStatement.json = { 'actor': {}, 'context': {}, 'verb': {}, 'object': {}, 'timestamp': '' };

                  for (var key in options) {
                        if (options.hasOwnProperty(key) && key !== 'description' && key !== 'mode' && key !== 'session' && key !== 'isDLSFormat' && key !== 'dlsStatementParams') {
                              interpretedStatement.json[key] = options[key];
                        }
                  }

                  interpretedStatement.json.context.platform = {};
                  if (typeof window !== 'undefined') interpretedStatement.json.context.platform.ua = window.navigator.userAgent;
                  if (options.session) interpretedStatement.json.context.platform.session = options.session;

                  interpretedStatement.json.verb.id = 'http://adlnet.gov/expapi/verbs/' + verb;

                  interpretedStatement.json.object.id = uniqueID;
                  interpretedStatement.json.timestamp = _helper2.default.getCurrentTimeISOStandard(dateTime);

                  interpretedStatement.description = options.description;
                  interpretedStatement.mode = options.mode;
                  interpretedStatement.generatedTimestamp = _helper2.default.getCurrentTime(dateTime);

                  interpretedStatementsArray.push(interpretedStatement);
                  return interpretedStatementsArray;
            }
      }]);

      return XAPIDataGenerator;
}();

exports.XAPIDataGenerator = XAPIDataGenerator;

/***/ })

/******/ });
});
